import { Budget } from '../../../../@types/budget';
import { numberOnly } from '../../../../services/helpers/mask';
import { sendWhatsappMessage } from '../../../../utils/sendWhatsappMessage';

export const handleWhatsappMessage = (
  budget: Budget,
  workshopFantasyName: string,
) => {
  const budgetUserName = budget.user ? budget.user.name : budget.name;

  const linkText = `Olá, ${encodeURIComponent(
    budgetUserName,
  )}! Segue o orçamento da *${encodeURIComponent(
    workshopFantasyName,
  )}*%0A%0Ahttps://oficinas.autocenterapp.com/budget-report?budgetId=${
    budget.id_budget
  }%0A%0A🛞Veículo: ${
    encodeURIComponent(budget.vehicle ? budget.vehicle : 'não informado') ||
    'não informado'
  } %0A🚘Placa: ${encodeURIComponent(
    budget.plate,
  )}%0A%0A%0A>%20⚠️ Os valores apresentados no orçamento estão sujeitos a alterações.%0A%0A%0ABaixe nosso app Autocenter!%0A%0Ahttps://onelink.to/629pmh
      %0A%0A%0ACaso o link não esteja clicável, responda essa mensagem, ou, copie o link e insira em um navegador de sua preferência para acessar o conteúdo.
      `;

  sendWhatsappMessage(
    linkText,
    budget.user ? budget.user.phone : `+55${numberOnly(budget.phone)}`,
  );
};
